const EventEmitter = {
    _events: {},
    dispatch(event, data) {
        //console.log('dispatch', event);
        if (!this._events[event]) return;
        this._events[event].forEach(callback => callback(data));
    },
    subscribe(event, callback) {
        //console.log('subscribe', event);
        if (!this._events[event]) this._events[event] = [];
        this._events[event].push(callback);
    },
    unsubscribe(event, callback) {
        //console.log('unsubscribe', event);
        if (!this._events[event]) return;
        // No callback → remove every handler for the event (legacy behavior,
        // relied on by callers like ReactFormBuilder/toolbar.jsx).
        if (!callback) {
            delete this._events[event];
            return;
        }
        // Otherwise remove only the matching handler so co-subscribers (e.g.
        // another mounted form component listening on the same event) survive.
        this._events[event] = this._events[event].filter(cb => cb !== callback);
        if (this._events[event].length === 0) delete this._events[event];
    }
};
export default EventEmitter;
